import * as $ from 'jquery';
import Fullpage from 'fullpage.js'
import '@splidejs/splide/dist/js/splide.js';
import MicroModal from 'micromodal';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import imagesLoaded from 'imagesloaded';
import videojs from 'video.js/dist/video.min.js';

window.$ = window.jQuery = $;

let fullpage;
let lastSectionIdx = 0;
let splides = [];

$(function() {
    imagesLoaded('body', { background: true }, function() {
      $('[data-js="loading"]').hide();
    });

    // ボタンでメニューを開く
    $('[data-js="menu-trigger"]').on('click', function() {
        $('[data-js="menu"]').removeClass('initial').addClass('is-open');
    });

    // ボタンでメニューを閉じる
    $('[data-js="menu-closer"]').on('click', function() {
        $('[data-js="menu"]').removeClass('is-open');
    });

    // ホバーで言語メニューを開く
    $('[data-js="locale-menu-wrapper"]').on('mouseenter', function() {
      $('[data-js="locale-menu"]').removeClass('initial').addClass('is-open');
    });

    // マウスアウトで言語メニューを閉じる
    $('[data-js="locale-menu-wrapper"]').on('mouseleave', function() {
      $('[data-js="locale-menu"]').removeClass('is-open');
    });

    // 各セクションのスライドショーを初期化
    for (let el of $('.main-scroller .splide').toArray()) {
      let splide = new Splide(el, {
        type: 'fade',
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        rewind: true,
        arrows: false,
        drag: false,
        direction: 'ttb',
        height: '100vh',
        speed: 4000,
        interval: 4000,
      });
      splide.mount();
      splide.Components.Autoplay.pause();
      splides.push(splide);
    }

    // Fullpage.jsを初期化
    initFullpage();

    // モーダルを初期化
    MicroModal.init({
      onShow: modal => { pauseFullpage(modal); },
      onClose: modal => { resumeFullpage(); },
    });
});

// 全画面のページ単位スクロールを初期化する
// セクション遷移時に、見えていないセクションのスライドショーは再生を停止する
function initFullpage() {
  fullpage = new Fullpage('[data-js="fullpage"]', {
    licenseKey: 'D51D2F58-CDD84CB2-B66553C8-65533730',
    scrollingSpeed: 800,
    afterLoad: function(origin, destination, direction) {
      if (splides[origin.index]) splides[origin.index].Components.Autoplay.pause();
      if (splides[destination.index]) splides[destination.index].Components.Autoplay.play();
    },
  });
}

// モーダルを開いたときに背後のfullpageの現在のページを記憶する
// （モーダルが開いている間に背後のページをスクロール操作してしまうことがあるので）
// スライドショーも一時停止する
function pauseFullpage(modal) {
  disableBodyScroll($(modal).find('.modal-container')[0]);
  lastSectionIdx = fullpage.getActiveSection().index;
  if (splides[lastSectionIdx]) splides[lastSectionIdx].Components.Autoplay.pause();
}

// モーダルを閉じたときに開いていたセクションに表示を戻す
// スライドショーも再開する
function resumeFullpage() {
  clearAllBodyScrollLocks();
  fullpage.silentMoveTo(lastSectionIdx + 1);
  if (splides[lastSectionIdx]) splides[lastSectionIdx].Components.Autoplay.play();
}
